import { ControllerHelper, MailTemplateDownloadDto, MediaController } from "collaboration-service";
import { EditorsSC as T } from "components/PostEdit/Editors/EditorsSC";
import SafeHTML from "components/SafeHTML/SafeHTML";
import { belowBreakpointOrEqual, Button, getUriFromLinkByName, Modal, styled, Theme } from "imaginarity-react-ui";
import * as _ from "lodash";
import * as React from "react";
import { useSelector } from "react-redux";
import { ApplicationState } from "services/ApplicationState/ApplicationState";
import { getTranslated } from "services/Helpers/TranslationHelpers";
import { useImgI18N } from "services/ImgI18N";
import { ThemeContext } from "styled-components";

interface MailTemplateSelectionProps {
    namespace?: string;
    active?: boolean;
    onSelect: (mail?: MailTemplateDownloadDto) => void;
    groupId?: string;
}

const MD = styled.div`
    p{
        line-height: 40px;
    }
`;

const MailTemplateSelection = (p: MailTemplateSelectionProps) => {
    const { groupId: givenGroupId } = p;
    const params = useSelector((s: ApplicationState) => s.params);
    const contentLanguage = useSelector((s: ApplicationState) => s.contentLanguage);
    const { namespace, active, onSelect } = p;
    const { t, } = useImgI18N(namespace ?? "general");
    //const {} = useSelector(mapper, shallowCompare);
    const [templates, setTemplates] = React.useState<MailTemplateDownloadDto[]>();
    const groupId = givenGroupId ?? params?.groupid as string;
    //console.log("MailTemplateSelection.tsx::28 => groupId", groupId);
    const theme = React.useContext<Theme>(ThemeContext);
    const smallDevice = belowBreakpointOrEqual({ theme }, "tablet");

    React.useEffect(() => {
        const load = async () => {
            if (groupId) {
                const res = await ControllerHelper.singleCall({ groupId }, MediaController.GetMailTemplates, true);
                setTemplates(res?.elements ?? []);
            }
            else {
                setTemplates([]);
            }
        }
        load();
    }, [groupId])


    return (
        <Modal active={active}
            icon="mail"
            header={t("select mail template")}
            height="large"
            width={smallDevice ? "full" : "default"}
            footer={<Button kind="cancelButton" floated='right' icon="times" content={t("cancel")} onClick={() => onSelect()} />}
        >
            <MD>
                <T.G1 style={{ fontWeight: "bolder", background: "rgba(0,0,0,0.05)" }}>
                    <T.L>{t("mail template name")}</T.L>
                    <T.D></T.D>
                    <T.D></T.D>

                </T.G1>

                {_.map(templates, (cc, i) => {
                    const cl = () => {
                        onSelect(cc);
                    }
                    return (
                        <T.G1 key={`${cc.id}-${i}`}>
                            <T.D style={{ paddingLeft: 10 }}>
                                <SafeHTML html={getTranslated(cc.names, contentLanguage)?.text ?? ""} />
                            </T.D>
                            <T.D>
                                <a href={getUriFromLinkByName(getTranslated(cc.templates, contentLanguage), "self")} target="_blank" rel="noreferrer">
                                    <Button tooltip={{ tooltipText: t("preview in new tab") }} floated="left" icon="eye open" kind="halfTransparentButton" />
                                </a>
                            </T.D>
                            <T.D>
                                <Button kind="halfTransparentButton" icon="copy" content={t("select")} onClick={cl} />
                            </T.D>
                        </T.G1>
                    )
                })}
            </MD>
        </Modal>
    )
}

export default MailTemplateSelection;